import { useState } from 'react';
import {
  AccountBalanceWalletOutlined,
  ShoppingCartOutlined,
  Redeem,
  QuestionMark,
  Person,
  Logout,
} from '@mui/icons-material';
import { MenuOptions } from 'models';
import BurgerMenu from 'components/BurgerMenu';
import NavMenu from 'components/NavMenu';
import { Link, useHistory } from 'react-router-dom';
import { useStore, useLocalStorage, useAuth, useFeatureFlag } from 'providers';
import { pushAnalyticsEvent } from 'helpers/analytics';
import ReferAndEarnIcon from 'assets/icons/ReferAndEarnIcon';
import { ROUTES } from 'constants/routes';
import WinASliceIconDesktop from 'assets/icons/WinASliceIconDesktop';
import {
  StyledHeader,
  StyledToolbar,
  ButtonWrapper,
  BackButton,
  BackButtonIcon,
  HomeButton,
  HomeButtonIcon,
} from './Header.styles';

function Header() {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const history = useHistory();
  const { signOut } = useAuth();
  const { store } = useStore();
  const { vouchersData } = store;
  const { getFromStorage } = useLocalStorage();

  const totalVouchers = vouchersData?.active.length || 0;
  const hasNewVouchers = !!getFromStorage<boolean>('hasNewVouchers');

  const homeUrl = '/';
  const currentPage = history.location.pathname;
  const isHome = currentPage === homeUrl;

  const allowWinASlice = useFeatureFlag('allowWinASlice');

  const onSignOut = async () => {
    try {
      localStorage.setItem('clickedLogout', 'true');
      await signOut();
      sessionStorage.removeItem('showWelcomeNotification');
    } catch (e) {
      pushAnalyticsEvent({
        event: 'userSignOutError',
        data: e,
      });
    }
  };

  const onNavigateToWinASlice = () => {
    pushAnalyticsEvent({ event: 'winASlice', title: 'Navigation Bar' });
    history.push({ pathname: ROUTES.WIN_A_SLICE });
  };

  const options: MenuOptions[] = [
    {
      path: ROUTES.PERKZ_WALLET,
      label: 'Perkz Wallet',
      icon: AccountBalanceWalletOutlined,
      showBadge: true,
    },
    {
      path: ROUTES.PERKZ_STORE,
      label: 'Perkz Store',
      icon: ShoppingCartOutlined,
      iconProps: {
        color: 'primary',
      },
    },
    {
      path: ROUTES.CLAIM_ZS,
      label: 'Claim Zs',
      icon: Redeem,
    },
    {
      path: ROUTES.REFER_A_FRIEND,
      label: 'Refer And Earn',
      icon: ReferAndEarnIcon,
      iconProps: {
        fill: 'primary',
      },
    },
    {
      path: ROUTES.HOW_IT_WORKS,
      label: 'How it Works',
      icon: QuestionMark,
    },
    {
      path: ROUTES.PROFILE,
      label: 'Profile',
      icon: Person,
    },
    {
      path: '#',
      label: 'Sign Out',
      icon: Logout,
      onClick: onSignOut,
    },
  ];

  const handleOnToggle = () => {
    setIsVisible(!isVisible);
  };

  const winASlice = {
    path: ROUTES.WIN_A_SLICE,
    label: 'Win a Slice',
    icon: WinASliceIconDesktop,
    iconProps: {
      color: 'primary',
    },
    onClick: onNavigateToWinASlice,
  };

  if (allowWinASlice) options.splice(3, 0, winASlice);

  return (
    <StyledHeader position="sticky" aria-label="App Toolbar">
      <StyledToolbar>
        <ButtonWrapper>
          {!isHome && (
            <BackButton onClick={history.goBack}>
              <BackButtonIcon />
            </BackButton>
          )}
          <HomeButton component={Link} to={homeUrl}>
            <HomeButtonIcon />
          </HomeButton>
        </ButtonWrapper>
        <BurgerMenu
          options={options}
          isVisible={isVisible}
          onToggle={handleOnToggle}
          totalVouchers={totalVouchers}
          hasNewVouchers={hasNewVouchers}
        />
        <NavMenu options={options} hasNewVouchers={hasNewVouchers} totalVouchers={totalVouchers} />
      </StyledToolbar>
    </StyledHeader>
  );
}

export default Header;
